import React from 'react';
import Icon from 'components/Icon/Icon';
import classes from './FullPageLoader.module.css';

interface FullPageLoaderProps {
  isOpen?: boolean;
}

function FullPageLoader({ isOpen = true }: FullPageLoaderProps) {
  if (!isOpen) return null;

  return (
    <div className={classes.loadingIcon} data-testid="full-page-loader">
      <Icon iconName="animatedCircle" />
    </div>
  );
}

export default FullPageLoader;
